import { render, staticRenderFns } from "./SecondTemplate.vue?vue&type=template&id=b2190b52&scoped=true&"
import script from "./SecondTemplate.vue?vue&type=script&lang=js&"
export * from "./SecondTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SecondTemplate.vue?vue&type=style&index=0&id=b2190b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2190b52",
  null
  
)

export default component.exports